export const quotationStates=['Brouillon','Créé','Envoyé','En négociation','Signé','Refusé','Remplacé'];
export const quotationState=quotation=>quotation.workflow?.state || (quotation.isDraft?'Brouillon':'Créé');
export function quotationStatusTotals(rows) {
 const totals=Object.fromEntries(quotationStates.map(state=>[state,0]));
 for(const {quotation} of rows){const state=quotationState(quotation);totals[state]=(totals[state]||0)+1;}
 return {all:rows.length,...totals};
}
